module.exports = __webpack_public_path__ + "img/logo.a569bdff.png";